"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseAgendaContextProvider = exports.useCourseAgendaContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var course_1 = require("../../../../utils/course");
var CourseAgendaContext = react_1.default.createContext({
    notFinishedTopics: [],
    finishedTopicIds: [],
    lessons: [],
    lockedLessonsIds: [],
    lockedTopicsIds: [],
    flatTopics: [],
    currentLesson: undefined,
    currentLessonParentLessonsIds: [],
    positionInLessonOfFirstBlockingTopic: -1,
    percentage: 0,
    currentNotLockedTopicId: undefined,
    areAllTopicsUnlocked: false,
    availableTopicsIds: [],
    onMarkFinished: function () { return console.warn("INITIAL STATE!"); },
    onTopicClick: function () { return console.warn("INITIAL STATE!"); },
    onCourseFinished: function () { return console.warn("INITIAL STATE!"); },
    isMobile: false,
});
var useCourseAgendaContext = function () { return (0, react_1.useContext)(CourseAgendaContext); };
exports.useCourseAgendaContext = useCourseAgendaContext;
var CourseAgendaContextProvider = function (_a) {
    var children = _a.children, currentTopicId = _a.currentTopicId, lessons = _a.lessons, finishedTopicIds = _a.finishedTopicIds, areAllTopicsUnlocked = _a.areAllTopicsUnlocked, availableTopicsIds = _a.availableTopicsIds, onTopicClick = _a.onTopicClick, onMarkFinished = _a.onMarkFinished, onCourseFinished = _a.onCourseFinished, isMobile = _a.isMobile;
    var flatTopics = (0, react_1.useMemo)(function () { return (0, course_1.getFlatTopics)(lessons); }, [lessons]);
    var flatLessons = (0, react_1.useMemo)(function () { return (0, course_1.getFlatLessons)(lessons !== null && lessons !== void 0 ? lessons : []); }, [lessons]);
    var firstBlockingTopic = (0, react_1.useMemo)(function () {
        return flatTopics.find(function (t) { return !finishedTopicIds.includes(t.id) && !t.can_skip; });
    }, [finishedTopicIds, currentTopicId]);
    var indexOfFirstLessonWithBlockingTopic = (0, react_1.useMemo)(function () { return flatLessons.findIndex(function (l) { return l.id === (firstBlockingTopic === null || firstBlockingTopic === void 0 ? void 0 : firstBlockingTopic.lesson_id); }); }, [flatLessons, firstBlockingTopic]);
    var indexOfFirstBlockingTopic = (0, react_1.useMemo)(function () { return flatTopics.findIndex(function (t) { return t.id === (firstBlockingTopic === null || firstBlockingTopic === void 0 ? void 0 : firstBlockingTopic.id); }); }, [flatTopics, firstBlockingTopic === null || firstBlockingTopic === void 0 ? void 0 : firstBlockingTopic.id]);
    var positionInLessonOfFirstBlockingTopic = (0, react_1.useMemo)(function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = flatLessons === null || flatLessons === void 0 ? void 0 : flatLessons[indexOfFirstLessonWithBlockingTopic]) === null || _a === void 0 ? void 0 : _a.topics) === null || _b === void 0 ? void 0 : _b.findIndex(function (t) { return t.id === (firstBlockingTopic === null || firstBlockingTopic === void 0 ? void 0 : firstBlockingTopic.id); })) !== null && _c !== void 0 ? _c : -1;
    }, [indexOfFirstLessonWithBlockingTopic, firstBlockingTopic === null || firstBlockingTopic === void 0 ? void 0 : firstBlockingTopic.id, flatLessons]);
    var lockedTopicsIds = (0, react_1.useMemo)(function () {
        return indexOfFirstBlockingTopic !== -1
            ? flatTopics.reduce(function (acc, t, i) {
                if (i <= indexOfFirstBlockingTopic)
                    return acc;
                if (t.id === undefined)
                    return acc;
                return __spreadArray(__spreadArray([], acc, true), [t.id], false);
            }, [])
            : [];
    }, [indexOfFirstBlockingTopic]);
    var lockedLessonsIds = (0, react_1.useMemo)(function () {
        return indexOfFirstLessonWithBlockingTopic !== -1
            ? flatLessons.reduce(function (acc, l, i) {
                if (i <= indexOfFirstLessonWithBlockingTopic)
                    return acc;
                return __spreadArray(__spreadArray([], acc, true), [l.id], false);
            }, [])
            : [];
    }, [indexOfFirstLessonWithBlockingTopic, flatLessons]);
    // if prop 'currentTopicId' refers to locked topic, then current topic is firstBlockingTopic
    var currentNotLockedTopicId = (0, react_1.useMemo)(function () {
        return lockedTopicsIds.includes(currentTopicId)
            ? firstBlockingTopic === null || firstBlockingTopic === void 0 ? void 0 : firstBlockingTopic.id
            : currentTopicId;
    }, [lockedTopicsIds, firstBlockingTopic, currentTopicId]);
    var currentLesson = (0, react_1.useMemo)(function () {
        return flatLessons.find(function (l) { var _a; return ((_a = l === null || l === void 0 ? void 0 : l.topics) !== null && _a !== void 0 ? _a : []).find(function (t) { return t.id === currentNotLockedTopicId; }); });
    }, [flatLessons, currentNotLockedTopicId]);
    var percentage = (0, react_1.useMemo)(function () {
        return Math.round((finishedTopicIds.length / flatTopics.length) * 100);
    }, [flatTopics, finishedTopicIds]);
    var notFinishedTopics = (0, react_1.useMemo)(function () { return flatTopics.filter(function (t) { return !finishedTopicIds.includes(t.id); }); }, [flatLessons.length, finishedTopicIds.length]);
    var currentLessonParentLessonsIds = (0, react_1.useMemo)(function () {
        return currentLesson ? (0, course_1.getLessonParentsIds)(flatLessons, currentLesson) : [];
    }, [flatLessons, currentLesson]);
    return ((0, jsx_runtime_1.jsx)(CourseAgendaContext.Provider, __assign({ value: {
            finishedTopicIds: finishedTopicIds,
            lessons: lessons,
            firstBlockingTopic: firstBlockingTopic,
            positionInLessonOfFirstBlockingTopic: positionInLessonOfFirstBlockingTopic,
            flatTopics: flatTopics,
            lockedLessonsIds: lockedLessonsIds,
            lockedTopicsIds: lockedTopicsIds,
            currentNotLockedTopicId: currentNotLockedTopicId,
            percentage: percentage,
            notFinishedTopics: notFinishedTopics,
            currentLesson: currentLesson,
            currentLessonParentLessonsIds: currentLessonParentLessonsIds,
            areAllTopicsUnlocked: areAllTopicsUnlocked,
            availableTopicsIds: availableTopicsIds,
            onMarkFinished: onMarkFinished,
            onTopicClick: onTopicClick,
            onCourseFinished: onCourseFinished,
            isMobile: isMobile,
        } }, { children: children })));
};
exports.CourseAgendaContextProvider = CourseAgendaContextProvider;
